export default __webpack_public_path__ + "static/exp4-26511ebd702edc965258414176072ec2.png";